export default __webpack_public_path__ + "63ad748fc0a6b4054130b892e3e17545.png";